import { render, staticRenderFns } from "./Ward.vue?vue&type=template&id=5766caec&"
import script from "./Ward.vue?vue&type=script&lang=js&"
export * from "./Ward.vue?vue&type=script&lang=js&"
import style0 from "./Ward.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports